import React, { useState, useEffect } from 'react';
import { Form, label, Button, Alert, Spinner, Col, Row, FormGroup } from 'react-bootstrap';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import { BiLeftArrowAlt } from "react-icons/bi";
import AudioRecorder from './AudioRecorder';
import ZPOCSpeech from './ZPOCSpeech';
import MicRecordAndTranslater from './MicRecorder';


const AddJobPostPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const jobInfo = location?.state?.jobInfo;
  //   const JOBID = searchParams.get('id');
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  // const history = useHistory();
  const [jobDetails, setJobDetails] = useState({
    job_rec_id: '',
    recuiter_questions_input: "",
    testSeconds: 60,
    jd_of_candidate_input: "",
    level_for_recuiter_jd: "intermediate",
    number_of_jd_questions: '1',
    job_name: '',
    jobDescription: '',
    jobSkills: '',
    createdBy: aminInfo?.user_id,
    client_id: '',
    openings_count: 1,
    coding_technologies: '',
    testMinutes: 30,
    coding_q_level: 'intermediate',
    coding_q_questions_count: 1,
    client_category: '',
  });


  useEffect(() => {
    console.log("jobinfo", jobInfo);
    // Check if jobInfo exists before updating jobDetails
    if (jobInfo) {
      setJobDetails((prevJobDetails) => ({
        ...prevJobDetails,
        job_rec_id: jobInfo?.job_rec_id,
        recuiter_questions_input: jobInfo?.recuiter_questions_input,
        testSeconds: jobInfo?.test_time,
        jd_of_candidate_input: jobInfo?.jd_of_candidate_input,
        level_for_recuiter_jd: jobInfo.level_for_recuiter_jd,
        number_of_jd_questions: jobInfo.number_of_jd_questions,
        job_name: jobInfo.job_name,
        jobDescription: '',
        jobSkills: '',
        createdBy: jobInfo.create_by,
        client_id: jobInfo.client_id,
        openings_count: jobInfo.openings_count,
        job_id: jobInfo?.job_id,
        coding_technologies: jobInfo.coding_q_tech,
        testMinutes: jobInfo.coding_q_time / 60,
        coding_q_level: jobInfo.coding_q_level,
        coding_q_questions_count: jobInfo.coding_q_questions_count,
        client_category: jobInfo?.client_category

      }));
      setAiQuestions(jobInfo.ai_question_type)
      if (jobInfo.jd_questions_type === 1) {
        setJdQuestions(jobInfo.jd_questions_type)
        setJobTextArea(true)
      }
      if (jobInfo.recuiter_questions_type === 1) {
        setClientCheckbox(jobInfo.recuiter_questions_type)
        setShowTextArea(true)
      }
      if (jobInfo.coding_q_enabled === 1) {
        setCodingInterviewStatus(jobInfo.coding_q_enabled)
        setShowCdInterviewFields(true)
      }if(jobInfo?.client_category === 'HOSPITALITY' || jobInfo?.client_category === 'HEALTH_CARE'){
        setCategorybasedFlag(false);
      }
    } else {
      setJobDetails({
        job_rec_id: '',
        recuiter_questions_input: "",
        testSeconds: 60,
        jd_of_candidate_input: "",
        level_for_recuiter_jd: "intermediate",
        number_of_jd_questions: '1',
        job_name: '',
        jobDescription: '',
        jobSkills: '',
        createdBy: aminInfo?.user_id,
        client_id: '',
        openings_count: 1,
        coding_technologies: "",
        testMinutes: 30,
        coding_q_level: 'intermediate',
        coding_q_questions_count: 1,
      });
      setJdQuestions(0)
      setAiQuestions(0)
      setClientCheckbox(0)
      setShowTextArea(false)
      setJobTextArea(false)
      setShowCdInterviewFields(false);
    }
  }, [jobInfo])

  const [validated, setValidated] = useState(false);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [showJobTextArea, setJobTextArea] = useState(false);
  const [showJDDescBool, setJDDescBool] = useState(false);
  const [aiQuestions, setAiQuestions] = useState(0);
  const [jdQuestions, setJdQuestions] = useState(0);
  const [clientCheckbox, setClientCheckbox] = useState(0);
  const [respSuccess, setRespSuccess] = useState('')
  const [updatejdFlag, setUpdatejdFlag] = useState(false)
  const [codingInterviewStatus, setCodingInterviewStatus] = useState(0);
  const [showCdInterviewFields, setShowCdInterviewFields] = useState(false);
  const [categorybasedFlag, setCategorybasedFlag] = useState(true);
  const [clientCategory, setclientCategory] = useState('');
  const [jd_desc, setJd_desc] = useState('');
  const [jdTranscibedSpeech, setJdTranscribedSpeech] = useState('');
  const [jdLoading, setJdLoading] = useState(false);

  //jd 'describe job' box
  const handleJdDescChange = (event) => {
    const typedText = event.target.value;
    setJd_desc(typedText);
};

const handleTranscriptionComplete = (text) => {
    setJd_desc(prevDesc => prevDesc + ' ' + text); // Append transcribed text to existing jd_desc
    setJdTranscribedSpeech(''); // Clear transcribed speech after appending
};


  const generateJobDescription = async () => {
    setJdLoading(true);
    const endpoint = 'admin_in/candidate-interview/gen_jd';
    const data = { jd_description: jd_desc };

    try {
      const response = await postData(endpoint, data);
      if (!response.ok) {
        setJdLoading(false);
        throw new Error('Network response was not ok.');
      }
      const responseData = await response.json();
      const parsedBody = JSON.parse(responseData.body);
      const extractedData = parsedBody.response;
      setJobDetails(prevDetails => ({
        ...prevDetails,
        jd_of_candidate_input: extractedData,
      }));
      setJdLoading(false);
      console.log(extractedData);
    } catch (error) {
      setJdLoading(false);
      console.error('Error generating job description:', error);
    }
  };

  const handleJdDescCheckbox = (event) => {
    setJDDescBool(event.target.checked ? true : false);
  }

  const handleCheckBoxChange = (e) => {
    setShowTextArea(e.target.checked);
    jobDetails.recuiter_questions_input = "";
    setClientCheckbox(e.target.checked ? 1 : 0);

  };
  const handleJobCheckBoxChange = (e) => {
    setJobTextArea(e.target.checked);
    jobDetails.jd_of_candidate_input = "";
    setJdQuestions(e.target.checked ? 1 : 0);
  }
  const handleAiCheckbox = (event) => {
    setAiQuestions(event.target.checked ? 1 : 0);
  }
  const handlecdInterviewcheckboxChange = (e) => {
    setShowCdInterviewFields(e.target.checked);
    jobDetails.coding_technologies = "";
    setCodingInterviewStatus(e.target.checked ? 1 : 0)
  }

  const handleChangeClient = (e) => {
    const { name, value } = e.target;
    const selectedClientObject = clientList.find((client) => client.client_id === value);
    console.log("selectedClientObject", selectedClientObject)
    setJobDetails((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
    if(selectedClientObject?.client_category === 'HOSPITALITY' || selectedClientObject?.client_category === 'HEALTH_CARE'){
      setCategorybasedFlag(false)
    } else {
      setCategorybasedFlag(true)
    }
    setclientCategory(selectedClientObject?.client_category)
    console.log("category", selectedClientObject.client_category, "@@@@", categorybasedFlag)
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobDetails((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
  };

  const numberChange = (event) => {
    const inputValue = event.target.value;
    if (!/[A-Z!@#$%^&*()_+{}[\]:;<>,.?~=/\\-]/.test(inputValue) && !/[a-z]/.test(inputValue)) {
      const { name, value } = event.target;
      setJobDetails((prevCandidate) => ({
        ...prevCandidate,
        [name]: value,
      }))

    }
    else {
      // event.preventDefault();

    }
  }

  const aiQuestionsCheckbox = document.getElementById('aiQuestionsCheckbox');
  const clientQuestionsCheckbox = document.getElementById('clientQuestionsCheckbox');
  const jobDescCheckbox = document.getElementById('jobDescCheckbox');
  const cdinterviewCheckbox = document.getElementById('cdinterviewCheckbox');
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('')
    const form = e.currentTarget;
    const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
    const orgID = localStorage.getItem('org_id');
    if (form.checkValidity()) {
      // console.log('Submitted:', jobDetails);
      if (!aiQuestionsCheckbox?.checked && !clientQuestionsCheckbox?.checked && !jobDescCheckbox?.checked && !cdinterviewCheckbox?.checked) {
        setSuccess('Please select at least one checkbox.');
        return;
      }
      if (clientQuestionsCheckbox.checked) {
        if (!jobDetails.recuiter_questions_input.trim()) {
          setSuccess('Please Enter at least one Question.');
          return;
        }
      }
      if (jobDescCheckbox.checked) {
        if (!jobDetails.jd_of_candidate_input.trim()) {
          setSuccess("Please Enter Job Description");
          return;
        }
      }
      if (jobDetails.job_rec_id === null) {
        setSuccess("Please Select job Id");
        return;
      } if (jobDetails.number_of_jd_questions > 10) {
        setSuccess("Please Select Jd Questions maximum 10 Only");
        return;
      }
      // if(jobDetails.testSeconds > 10){
      //     setSuccess('Please Enter testSeconds Less Than Or Equals To 10');
      //     return;
      // }
      //Redirect to tech selector
      if (!jobInfo) {
        const payload2 = {
          "job_name": jobDetails.job_name,
          "jd_of_candidate_input": jobDetails.jd_of_candidate_input,
          // "job_skills": jobDetails.jobSkills,
          "openings_count": jobDetails.openings_count,
          "create_by": aminInfo?.user_id,
          "client_id": jobDetails.client_id,
          "job_rec_id": jobDetails.job_rec_id,
          "jd_questions_type": jdQuestions,
          "recuiter_questions_type": clientCheckbox,
          "ai_question_type": aiQuestions,
          "level_for_recuiter_jd": jobDetails.level_for_recuiter_jd,
          "test_time": jobDetails.testSeconds,
          "number_of_jd_questions": jobDetails.number_of_jd_questions,
          "recuiter_questions_input": jobDetails.recuiter_questions_input,
          "coding_q_enabled": codingInterviewStatus,
          "coding_q_tech": jobDetails.coding_technologies,
          "coding_q_time": jobDetails.testMinutes,
          "coding_q_questions_count": jobDetails.coding_q_questions_count,
          "coding_q_level": jobDetails.coding_q_level,
          client_category: clientCategory
        }

        setLoading(true);
        try {
          await postData('admin_in/job/add-new-job', payload2).then(resp => {
            resp.json().then(respData => {
              if (resp.status === 200) {
                if (respData.statusCode === 200) {
                  if (respData.message.toLowerCase() === 'success') {
                    setLoading(false);
                    setRespSuccess(respData.info);
                    if (jobDetails.job_rec_id !== "") {
                      localStorage.setItem("jobId", jobDetails.job_rec_id)
                    }
                    if (aiQuestions === 1) {
                      navigate(`/techselect?id=${respData.job_id}&cid=${respData.company_id}`);
                    } else {
                      console.log('no ai queastion')
                      setUpdatejdFlag(true);
                      // navigate(`/link-generator?id=${resp.job_id}`);
                    }
                    setTimeout(() => {
                      setJobDetails({
                        job_rec_id: '',
                        recuiter_questions_input: "",
                        testSeconds: 60,
                        jd_of_candidate_input: "",
                        level_for_recuiter_jd: "intermediate",
                        number_of_jd_questions: '1',
                        job_name: '',
                        jobDescription: '',
                        jobSkills: '',
                        createdBy: aminInfo?.user_id,
                        client_id: '',
                        openings_count: 1,
                        coding_technologies: "",
                        testMinutes: 5,
                        coding_q_level: 'intermediate',
                        coding_q_questions_count: 1,
                      });
                    }, 1000);

                    setJdQuestions(0)
                    setAiQuestions(0)
                    setClientCheckbox(0)
                    setJDDescBool(false);
                    setJd_desc('');
                  } else {
                    setLoading(false);
                    setSuccess(respData.info);
                  }

                } else if (respData.statusCode === 500) {
                  setLoading(false);
                  setSuccess(respData.info);
                } else {
                  setLoading(false);
                  setSuccess('Login failed. Please check your credentials.');
                }
              }
              else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                setLoading(false);
                console.log('resp status else if : ', resp.status);
                if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                  || respData.message === 'Access Denied') {
                  setLoading(false);
                  //   callRefreshTokenApi('getSfeBatch', '');
                }
                setSuccess('Looks Like Session Expired Please login..');
              } else {
                console.log('resp status else  : ', resp);
                setLoading(false);
              }
            }).catch((error) => {
              setSuccess('Network Error');
              console.log('network error:', error);
              setLoading(false);
            });
          }).catch((error) => {
            setLoading(false);
            setSuccess('Login failed. Please check your credentials or Network Error');
            console.log('network error:', error);

          });
        } catch (error) {
          setLoading(false);
          // Handle login error, e.g., display an error message to the user.
          console.error('Login failed', error);
        }
      } else {
        const payload = {
          "op": "update_basic",
          "job_id": jobDetails.job_id,
          "job_name": jobDetails.job_name,
          "openings_count": jobDetails.openings_count,
          "user_id": aminInfo?.user_id,
          "client_id": jobDetails.client_id,
          "job_rec_id": jobDetails.job_rec_id,
          "jd_questions_type": jdQuestions,
          "recuiter_questions_type": clientCheckbox,
          "ai_question_type": aiQuestions,
          "level_for_recuiter_jd": jobDetails.level_for_recuiter_jd,
          "test_time": jobDetails.testSeconds,
          "jd_of_candidate_input": jobDetails.jd_of_candidate_input,
          "number_of_jd_questions": jobDetails.number_of_jd_questions,
          "recuiter_questions_input": jobDetails.recuiter_questions_input,
          "coding_q_enabled": codingInterviewStatus,
          "coding_q_tech": jobDetails.coding_technologies,
          "coding_q_time": jobDetails.testMinutes,
          "coding_q_questions_count": jobDetails.coding_q_questions_count,
          "coding_q_level": jobDetails.coding_q_level,

        }
        setLoading(true);
        try {
          await postData('admin_in/job/update-job-details', payload).then(resp => {
            resp.json().then(respData => {
              if (resp.status === 200) {
                if (respData.statusCode === 200) {
                  if (respData.message.toLowerCase() === 'success') {
                    setLoading(false);
                    setRespSuccess(respData.info);
                    if (jobDetails.job_rec_id !== "") {
                      localStorage.setItem("jobId", jobDetails.job_rec_id)
                    }
                    if (aiQuestions === 1) {
                      navigate(`/techselect?id=${respData.job_id}&cid=${respData.company_id}`, { state: { update: "1" } });
                    } else {
                      console.log('no ai queastion')
                      setUpdatejdFlag(true)
                      // navigate(`/link-generator?id=${resp.job_id}`);
                    }
                    setTimeout(() => {
                      setJobDetails({
                        job_rec_id: '',
                        recuiter_questions_input: "",
                        testSeconds: 60,
                        jd_of_candidate_input: "",
                        level_for_recuiter_jd: "intermediate",
                        number_of_jd_questions: '1',
                        job_name: '',
                        jobDescription: '',
                        jobSkills: '',
                        createdBy: aminInfo?.user_id,
                        client_id: '',
                        openings_count: 1,
                        coding_technologies: "",
                        testMinutes: 5,
                        coding_q_level: 'intermediate',
                        coding_q_questions_count: 1,
                      });
                    }, 1000);



                  } else {
                    setLoading(false);
                    setSuccess(resp.info);
                  }

                } else if (respData.statusCode === 500) {
                  setLoading(false);
                  setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setSuccess('Login failed. Please check your credentials.');
                }
              } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                console.log('resp status else if : ', resp.status);
                if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                  || respData.message === 'Access Denied') {
                  setLoading(false);
                  //   callRefreshTokenApi('getSfeBatch', '');
                }
                setSuccess('Looks Like Session Expired Please login..');

              } else {
                console.log('resp status else  : ', resp);
                setLoading(false);
              }
            }).catch((error) => {
              setSuccess('Network Error');
              console.log('network error:', error);
              setLoading(false);
            });
          }).catch((error) => {
            setLoading(false);
            setSuccess('Login failed. Please check your credentials or Network Error');
            console.log('network error:', error);

          });
        } catch (error) {
          setLoading(false);
          // Handle login error, e.g., display an error message to the user.
          console.error('Login failed', error);
        }
      }


    } else {
      setValidated(true);
    }
  };

  const [clientList, setClientList] = useState([])

  useEffect(() => {

    const getClientList = async () => {
      const payload = {
        "user_id": aminInfo?.user_id
      }

      try {
        await postData('admin_in/clients/clients-list', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  setClientList(respData.dataJ);
                  setLoading(false);
                  //setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setSuccess(respData.info);
                }

              } else if (respData.statusCode === 500) {
                setLoading(false);
                setSuccess(respData.info);
              } else {
                setLoading(false);
                setSuccess('Job Clients Details failed. Please check your credentials.');
              }
            }
            else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                setLoading(false);
                //   callRefreshTokenApi('getSfeBatch', '');
              }
              setSuccess('Looks Like Session Expired Please login..');
            } else {
              console.log('resp status else  : ', resp);
              setLoading(false);
            }
          }).catch((error) => {
            setSuccess('Network Error');
            console.log('network error:', error);
            setLoading(false);
          });
        }).catch((error) => {
          setLoading(false);
          setSuccess('Job Clients Details failed. Please check your credentials or Network Error');
          console.log('network error:', error);

        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Job Clients Details failed', error);
      }

    }
    getClientList()

  }, [])

  const gotoJobsPage = () => {
    navigate('/job-post')
  }
  const backButton = () => {
    navigate(`/jobdetails?id=${jobInfo?.job_id}&category=${jobInfo?.client_category}`);
  }


  return (
    <div className='dashboard-div'>
      <NavHeader />
      <div className='page-title-heading'> {jobInfo ? 'Edit Job' : 'Add New Job'} </div>
      <div className='add-job-div'>
        {jobInfo && (<div className='' style={{ width: '100%', maxWidth: '800px', margin: 'auto', padding: '0px' }}> <BiLeftArrowAlt style={{ fontSize: '30px', cursor: 'pointer' }} onClick={backButton} /></div>)}
        <div className="details-div">
          {success && <Alert variant="danger">{success}</Alert>}
          <div style={{ display: 'flex', marginBottom: '5px' }}>
            <div style={{ width: '100%' }}>
              {respSuccess && <Alert variant="success" style={{ padding: '6px' }}>{respSuccess}</Alert>}
            </div>
            {updatejdFlag && (<div style={{ width: '100%' }}>
              <Button onClick={gotoJobsPage} className="Button-add" style={{ backgroundColor: 'black', marginLeft: '20px', marginBottom: '10px', width: '100%', maxWidth: '330px' }}>Go to Jobs Page</Button>
            </div>)}
          </div>

          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className='screen-styling'>
              <Form.Group controlId="formCountryCode" className='form-group-styling'>
                <Row>
                  <Col xs={12} md={12}>
                    <Form.Label className='form-label-styling'> Select Client</Form.Label>
                    <Form.Select
                      as="select"
                      name="client_id"
                      value={jobDetails.client_id}
                      onChange={handleChangeClient}
                      required
                    >
                      <option value="" >Select Client</option>
                      {clientList.map((client, index) => (
                        <option key={index} value={client.client_id}>
                          {`${client.client_name}`}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">Please Select Client.</Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group controlId="formCompany" className='form-group-styling' xs={6} md={12}>
                <Form.Label className='form-label-styling'>Job Name</Form.Label>
                <Form.Control
                  type="text"
                  name="job_name"
                  placeholder="Enter Job Name*"
                  value={jobDetails.job_name}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Job Name.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='screen-styling'>

              <Form.Group controlId="formSkills" className='form-group-styling'>
                <Row>
                  <Col xs={12} md={12}>
                    <Form.Label className='form-label-styling'>Job ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="job_rec_id"
                      placeholder="Enter Job ID*"
                      value={jobDetails.job_rec_id}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">Please Enter Job Id.</Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group controlId="formJobId" className='form-group-styling'>
                <Form.Label className='form-label-styling'>Opening Count</Form.Label>
                <Form.Control
                  type="number"
                  name="openings_count"
                  placeholder="Enter Openings Count*"
                  value={jobDetails.openings_count}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Opening Count.</Form.Control.Feedback>
              </Form.Group>
            </div>
            {/* <div className='screen-styling'>
            <Form.Group controlId="formName" style={{ marginBottom: '10px',width:'100%' }} >
              <Form.Control
                as="textarea"
                name="jobDescription"
                placeholder="Enter Job Description*"
                value={jobDetails.jobDescription}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">Please Enter A Job Description.</Form.Control.Feedback>
            </Form.Group>
  
            </div> */}
            <div className='screen-styling'>


            </div>
            <></>
            <Form.Group style={{ marginBottom: '10px', marginTop: '8px', position: 'relative' }}>
              <Row>
                <Col xs={6} sm={3}>
                  <Form.Check aria-label="option 1" label="JD(Job Description)" onChange={handleJobCheckBoxChange} id="jobDescCheckbox" style={{ fontSize: '15px' }} checked={jdQuestions === 1} />
                </Col>
                <Col xs={6} sm={3}>
                  <Form.Check aria-label="option 1" label="Custom Questions" onChange={handleCheckBoxChange} id="clientQuestionsCheckbox" style={{ fontSize: '15px' }} checked={clientCheckbox === 1} />
                </Col>
                 {categorybasedFlag && (<Col xs={6} sm={3} >
                  <Form.Check aria-label="option 1" label="Tech Questions" id="aiQuestionsCheckbox" style={{ fontSize: '15px' }} onChange={handleAiCheckbox} checked={aiQuestions === 1} />
                </Col>)} 
                <Col xs={6} sm={3}>
                  {/* <Form.Label className='form-label-styling-Time'>Time(Seconds) </Form.Label> */}
                  <legend className="scheduler-border-ing">
                    <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Time (Seconds)</div>
                  </legend>
                  <Form.Control
                    type="number"
                    name="testSeconds"
                    value={jobDetails.testSeconds}
                    onChange={handleChange}
                    placeholder="Enter Seconds"
                    style={{ width: '95%', fontSize: '14px' }}
                    min={60}
                    max={600}
                    isInvalid={(parseInt(jobDetails.testSeconds, 10) > 600 || parseInt(jobDetails.testSeconds, 10) < 60)}
                  />

                </Col>
                 {categorybasedFlag && (<Col xs={6} sm={3}>
                  <Form.Check aria-label="option 1" label="Coding Interview" id="cdinterviewCheckbox" style={{ fontSize: '15px' }} onChange={handlecdInterviewcheckboxChange} checked={codingInterviewStatus === 1} />
                </Col>
                )
                } 
              </Row>
            </Form.Group>

            <Form.Group controlId="formExamLevel" style={{ marginBottom: '10px' }}>
              <Row> {(showTextArea || showJobTextArea) &&
                <Col xs={6} style={{ paddingRight: '0px' }}>
                  <Form.Select
                    as="select"
                    name="level_for_recuiter_jd"
                    value={jobDetails.level_for_recuiter_jd}
                    onChange={handleChange}
                    required
                    style={{ width: '100%' }}
                  >
                    {/* Options for  exam levels */}
                    {/* <option value="testlevel">Testlevel for Client Questions </option> */}
                    <option value="beginner">Beginner </option>
                    <option value="intermediate">Intermediate</option>
                    <option value="experienced">Experienced</option>

                  </Form.Select>
                  <Form.Control.Feedback type="invalid">Please Select a Exam level.</Form.Control.Feedback>
                </Col>
              }
              </Row>

            </Form.Group>
            <div className='desc-container'>
              {showJobTextArea && (
                <div className="bordered-container">
                  <legend className="scheduler-border-ing">
                    <div className="legend-content" style={{ color: '#1d09e2', fontWeight: 600 }}>JD Questions</div>
                  </legend>


                  <div>
                    <Row>
                      <Col>
                        <Form.Group className='form-group-styling' as={Col} xs={6} style={{ marginBottom: '10px', marginTop: '10px' }}>
                          <Form.Label className='form-label-styling'>JD Questions Count</Form.Label>
                          <Form.Control
                            size="lg"
                            type="number"
                            name="number_of_jd_questions"
                            value={jobDetails.number_of_jd_questions}
                            onChange={handleChange}
                            placeholder="Enter no.of Jd questions"
                            style={{ width: '100%', fontSize: '14px', marginBottom: '10px' }}
                            max={10}
                            isInvalid={parseInt(jobDetails.number_of_jd_questions, 10) < 1 || parseInt(jobDetails.number_of_jd_questions, 10) > 10}
                          />
                          <Form.Control.Feedback type="invalid">Enter minimum 1 and maximum 10 Questions.</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group style={{ marginBottom: '10px', marginTop: '8px', position: 'relative' }}>
                          <Form.Check aria-label="option 1" label="Don't Have Job Description?" onChange={handleJdDescCheckbox} id="jobDescToggleCheckbox" style={{ fontSize: '15px' }} checked={showJDDescBool === true} />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>


                  <Row>
                    <Col xs={12} sm={showJDDescBool ? 6 : 12}>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={handleChange}
                        name="jd_of_candidate_input"
                        value={jobDetails.jd_of_candidate_input}
                        placeholder="Enter a job description here..."
                        required
                      />
                      <Form.Control.Feedback type="invalid">Please Enter Your Job Description.</Form.Control.Feedback>
                    </Col>

                    {showJDDescBool && (
                      <Col xs={6}>
                        <div>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={handleJdDescChange}
                            name="jd_description"
                            value={jd_desc}
                            placeholder="Don't have JD? Describe the job here..."
                          // required
                          ></Form.Control>
                          <Form.Control.Feedback type="invalid">Please Enter your best description of the job</Form.Control.Feedback>
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}>
                          <Button 
                              style={{ marginTop: '5px', width: '50%', padding: "5px" }} 
                              variant="dark" 
                              onClick={generateJobDescription}
                              disabled={jdLoading} // Disable button while loading
                          >
                              {jdLoading ? (
                                  <>
                                      <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
                                      Generating JD
                                  </>
                              ) : (
                                  <>Generate JD</>
                              )}
                          </Button>
                            
                            {/* <MicRecordAndTranslater
                              buttonStyle={{marginTop: '5px'}}
                              recordText=''
                              isRecordingText=''
                              onTranscribeHandle={handleTranscriptionComplete}
                            /> */}
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            </div>

            {showTextArea && (
              <div className="bordered-container">
                <legend className="scheduler-border-ing">
                  <div className="legend-contents" style={{color:'#1d09e2',fontWeight:600}}>Custom Questions</div>
                </legend>
                <Form.Group as={Col} xs={12} style={{ marginBottom: '10px', marginTop: '15px' }}>
                  <Form.Control as="textarea" rows={3} onChange={handleChange} name="recuiter_questions_input" value={jobDetails.recuiter_questions_input} placeholder='Please Add Custom Questions Here' required />
                  <Form.Control.Feedback type="invalid">Please Enter Atleast One Question.</Form.Control.Feedback>
                </Form.Group>
              </div>
            )}
            {/* {showCdInterviewFields &&(
            <Form.Group style={{marginBottom:'10px'}}>
              <Row>
                <Col  xs={5} sm={3} style={{paddingRight:'2px'}}>Coding Technologies</Col>
                
                <Col xs={6} sm={6}>
                  <Form.Control
                    type="number"
                    name="coding_technologies"
                    value={jobDetails.coding_technologies}
                    onChange={handleChange}
                    placeholder="Enter Technologies*"
                    style={{ width: '95%', fontSize: '14px' }}
                    
                   
                    isInvalid={(parseInt(jobDetails.testMinutes, 10) > 600 || parseInt(jobDetails.testSeconds, 10) < 60)}
                  />
                  <Form.Control.Feedback type="invalid">Question Time should be in between 60sec-600sec.</Form.Control.Feedback>

                </Col>
                <Col xs={6} sm={3}>
                  <Form.Label className='form-label-styling-Time'>Time(Seconds) </Form.Label>
                  <legend className="scheduler-border-ing">
                    <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Time (Seconds)</div>
                  </legend>
                  <Form.Control
                    type="number"
                    name="testMinutes"
                    value={jobDetails.testMinutes}
                    onChange={handleChange}
                    placeholder="Enter Seconds"
                    style={{ width: '95%', fontSize: '14px' }}
                    min={60}
                    max={600}
                    isInvalid={(parseInt(jobDetails.testMinutes, 10) > 600 || parseInt(jobDetails.testSeconds, 10) < 60)}
                  />
                  <Form.Control.Feedback type="invalid">Question Time should be in between 60sec-600sec.</Form.Control.Feedback>

                </Col>

                
              </Row>
            </Form.Group>)} */}

            {showCdInterviewFields && (
              <>
                <div className="bordered-container">
                  <legend className="scheduler-border-ing">
                    <div className="legend-contents" style={{ color: '#1d09e2', fontWeight: 600 }}>Coding Questions</div>
                  </legend>
                  <div className='screen-styling' style={{ padding: 10 }}>
                    <Form.Group controlId="formCompany" className='form-group-styling' xs={6} md={6}>
                      <Form.Label className='form-label-styling'>Coding Technologies</Form.Label>
                      <Form.Control
                        type="text"
                        name="coding_technologies"
                        placeholder="Enter Coding Technologies*"
                        value={jobDetails.coding_technologies}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">Please Enter Technologies.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formCompany" className='form-group-styling' xs={6} md={6}>
                      <legend className="scheduler-border-ing">
                        <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Time (Minutes)</div>
                      </legend>
                      <Form.Control
                        type="number"
                        name="testMinutes"
                        value={jobDetails.testMinutes}
                        onChange={handleChange}
                        placeholder="Enter Minutes"
                        style={{ width: '100%', fontSize: '14px', padding: '7px' }}
                        min={1}

                        isInvalid={(parseInt(jobDetails.testMinutes, 10) > 180 || parseInt(jobDetails.testMinutes, 10) < 1)}
                      />
                      <Form.Control.Feedback type="invalid">Question Time should be in between 1 min-180 min.</Form.Control.Feedback>

                    </Form.Group>

                  </div>
                  <div className='screen-styling' style={{ padding: 10 }}>
                    <Form.Group controlId="formCompany" className='form-group-styling' style={{ marginBottom: '10px' }} xs={6} md={6}>
                      <Form.Label className='form-label-styling'>Coding Level</Form.Label>
                      <Row>
                        <Col md={6} style={{ paddingRight: '0px' }}>
                          <Form.Select
                            as="select"
                            name="coding_q_level"
                            value={jobDetails.coding_q_level}
                            onChange={handleChange}
                            required
                            style={{ minWidth: '97%' }}
                          >
                            {/* Options for  exam levels */}
                            {/* <option value="testlevel">Testlevel for Client Questions </option> */}
                            <option value="beginner">Beginner </option>
                            <option value="intermediate">Intermediate</option>
                            <option value="experienced">Experienced</option>

                          </Form.Select>
                          <Form.Control.Feedback type="invalid">Please Select a Exam level.</Form.Control.Feedback>
                        </Col>

                      </Row>

                    </Form.Group>
                    {/* <Form.Group as={Col} xs={6} style={{ marginBottom: '10px' }}>
              <legend className="scheduler-border-ing">
                <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Questions Count</div>
              </legend>
              <Form.Control
                size="lg"
                type="number"
                name="coding_q_questions_count"
                value={jobDetails.coding_q_questions_count}
                onChange={handleChange}
                placeholder="Enter Questions Count"
                style={{ width: '100%', fontSize: '14px', marginBottom: '10px' }}
                max={10}
                isInvalid={
                  parseInt(jobDetails.coding_q_questions_count, 10) < 1 ||
                  parseInt(jobDetails.coding_q_questions_count, 10) > 10
                }
              />
              <Form.Control.Feedback type="invalid">Enter a value between 1 and 10 for Questions Count.</Form.Control.Feedback>
            </Form.Group> */}
                  </div>
                </div>
              </>
            )}

            {loading && (
              <div className="spinner-overlay">
                <Spinner animation="border" role="status">
                  <span className="sr-only"></span>
                </Spinner>
              </div>
            )}
            <Button type="submit" variant="dark" className="Button"> {jobInfo ? 'Update' : 'Submit'} </Button>

          </Form>
        </div>
        {/* <div style={{paddingBottom:'25px'}}>
      {showJobTextArea &&(
        <div  className='jobdesc-div'>
          <Row style={{margin:'0px'}}>
            <div className='info-title' style={{display:'flex',justifyContent:'center',paddingBottom:'10px',color:'#000'}}>Java Description Examples</div>
          </Row>
        <div>
        <Row>
          
          <div className='col-8' ><span className='info-title' >Java FullStack:</span><span className='info-data' style={{paddingLeft:'10px'}}>Java,SpringBoot,HTML,CSS,JavaScript</span></div>
          <div ><span className='info-title'>FrontEnd UI Developer:</span><span className='info-data'style={{paddingLeft:'10px'}}>HTML,CSS,JavaScript,Bootstrap,ReactJS</span></div>
          <div ><span className='info-title'>MicroProcessor:</span><span className='info-data' style={{paddingLeft:'10px'}}>MicroProcessor and Micro Controller,Electonic devices,Electric and Electonic Networks</span></div>
          <div ><span className='info-title'>backend Developer:</span><span className='info-data' style={{paddingLeft:'10px'}}>Python,Java,DynamoDB,MangoDB</span></div>
          <div ><span className='info-title'>System Admin:</span><span className='info-data' style={{paddingLeft:'10px'}}>Microsoft,Excel,Typing,Shortcut keys in Excel</span></div>
        </Row>
        </div>

      </div>
      
      )}
      </div> */}
      </div>
    </div>
  );
};

export default AddJobPostPage;